import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/图层11.png';
const _withScopeId = n => (_pushScopeId("data-v-383198a0"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "banner"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));
const _hoisted_2 = {
  class: "home-list"
};
const _hoisted_3 = {
  class: "home-list-main"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "company"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createElementVNode("h2", null, "公司介绍"), /*#__PURE__*/_createElementVNode("p", null, "公司经营范围：组织文化艺术交流活动;会议及展览服务:市场营销策划:企业形象策划:平面设计;广告设计、代理;广告发布:广告制作;信息咨询服务(不含许可类信息咨询服务):企业管理咨询:咨询策划服务;科技中介服务;社会经济咨询服务;图文设计制作;礼仪服务;互联网销售(除销售需要许可的商品):动漫游戏开发;软件开发;软件外包服务;网络与信息安全软件开发;数字技术服务;数据处理服务:数据处理和存储支持服务:信息系统集成服务:计算机系统服务;技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广;信息技术咨询服务;专业设计服务。(除依法须经批准的项目外，凭营业执照依法自主开展经营活动)许可项目:广播电视节目制作经营:第二类增值电信业务;第一类增值电信业务。(依法须经批准的项目，经相关部门批准后方可开展经营活动，具体经营项目以相关部门批准文件或许可证件为准)")])])], -1));
const _hoisted_5 = {
  class: "songBox"
};
const _hoisted_6 = ["autoplay", "src"];
import api from "@/api";
import PayList from "@/components/play-list/index.vue";
import router from "@/router";
import { reactive, ref, onMounted } from 'vue';
import { showConfirmDialog } from "vant";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const audio = new Audio();
    const currentId = ref(-1);
    const data = reactive({
      list: [],
      list1: [],
      status: false,
      userId: '',
      showList: true,
      songList: null,
      showRight: false,
      musicUrl: '',
      autoplay: false,
      itemPlay: null
    });
    onMounted(() => {
      var _JSON$parse;
      getlist();
      const User = window.localStorage.getItem('user');
      data.userId = (_JSON$parse = JSON.parse(User)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.id;
    });
    const getlist = async () => {
      let resulte = await api.getlist();
      let res = resulte.data.data;
      isPlay(res);
      data.list1 = res.splice(15);
      data.list = res;
    };
    audio.addEventListener("timeupdate", () => {
      let currentTime = audio.currentTime;
      if (currentTime >= 10) {
        if (!data.status) {
          audio.pause();
          pause();
          showConfirmDialog({
            title: '提示',
            message: '余额不足,请充值'
          }).then(() => {
            // on confirm
            router.push({
              path: '/recharge'
            });
          }).catch(() => {
            // on cancel
            data.showRight = false;
          });
        }
      }
    });
    const byPlay = async (userId, id) => {
      let status = await api.play(userId, id);
      data.status = status.data.code == '0';
    };
    const isPlay = res => {
      res.map(item => {
        item.isPlay = false;
        return item;
      });
    };
    const play = async item => {
      data.itemPlay = item;
      data.musicUrl = item.songUrl;
      data.songList = item.songGc;
      /* if(!window.localStorage.getItem('user')){
          await byPlay(item.id)
      }else{
          await byPlay(item.id)
      } */
      window.localStorage.getItem('user') ? await byPlay(data.userId, item.id) : await byPlay('1', item.id);
      if (currentId.value != item.id) {
        data.showRight = true;
        data.autoplay = true;
        audio.src = item.songUrl;
        plays(item);
      } else {
        if (audio.paused) {
          audio.play();
          plays(item);
        } else {
          audio.pause();
          pause();
        }
      }
    };
    const pause = () => {
      isPlay(data.list);
      isPlay(data.list1);
      audio.pause();
    };
    const plays = item => {
      audio.play().then(res => {
        currentId.value = item.id;
        item.isPlay = true;
      });
    };
    return (_ctx, _cache) => {
      const _component_van_overlay = _resolveComponent("van-overlay");
      return _openBlock(), _createElementBlock("div", null, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(PayList, {
        title: "潮流音乐",
        onPlay: play,
        list: data.list,
        src: require('../../../assets/组1.png')
      }, null, 8, ["list", "src"]), _createVNode(PayList, {
        title: "经典音乐",
        onPlay: play,
        list: data.list1,
        src: require('../../../assets/组2.png')
      }, null, 8, ["list", "src"])])]), _hoisted_4, _createVNode(_component_van_overlay, {
        show: data.showRight,
        onClick: _cache[1] || (_cache[1] = $event => data.showRight = false)
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("p", null, _toDisplayString(data.songList), 1)]), _createElementVNode("audio", {
          style: {
            "width": "500px",
            "margin": "50px auto 0"
          },
          autoplay: data.autoplay,
          onPlay: _cache[0] || (_cache[0] = $event => plays(data.itemPlay)),
          onPause: pause,
          controls: "true",
          src: data.musicUrl
        }, null, 40, _hoisted_6)]),
        _: 1
      }, 8, ["show"])]);
    };
  }
});